import React, { Component } from "react";

import styled from "styled-components/macro";
import { mediaQueries } from "../../styles/media.js";

import Heading from "../../components/Heading";
import List, { ListItem } from "../../components/List";

class OtherClientTodos extends Component {
  render() {
    if (!this.props.otherClients) {
      return null;
    }

    return (
      <>
        {this.props.otherClients.map((client, index) => {
          if (!client.doables?.length > 0) {
            return null;
          }

          return (
            <StyledOtherClientTodos key={index}>
              <Heading level="2" size="4">
                {/* One string in its own element, so React can update it after Chrome Translate rewrites the text */}
                <span>{`${client.first_name} has ${client.doables.length} ${client.doables.length > 1 ? "things" : "thing"} to do`}</span>
                <StyledSecondaryText>Tell them to log into their dashboard to complete these:</StyledSecondaryText>
              </Heading>
              <StyledList bullet>
                {client.doables.map((doable) => {
                  return <ListItem key={doable.id}>{doable.title}</ListItem>;
                })}
              </StyledList>
            </StyledOtherClientTodos>
          );
        })}
      </>
    );
  }
}

export default OtherClientTodos;

const StyledOtherClientTodos = styled.div`
  margin-top: 2em;

  li {
    font-size: var(--juno-font-size-body-sm);
  }
`;

const StyledSecondaryText = styled.div`
  font-weight: var(--juno-font-weight-regular);
  font-size: var(--juno-font-size-body-sm);
  color: var(--juno-color-text-secondary);
  padding-top: 0.5em;

  ${mediaQueries.md} {
    margin-bottom: -0.5em;
  }
`;

const StyledList = styled(List)`
  margin-top: 0;
`;
